module.exports = __webpack_public_path__ + "img/qarabag-logo-icon.df3a0101.png";